import { useSelector } from 'react-redux';
import { Calendar } from 'primereact/calendar';
import { Link, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { all_routes } from '../router/all_routes';
import { RootState } from '../../core/data/redux/store';
import dayjs from 'dayjs';
import moment from 'moment';
import { generateTimeOptions } from '../../core/data/redux/actions/commonActions';

const BookingCheckout = ({ setValue, watch, nextStep }: any) => {
  const routes = all_routes;
  const { vin } = useParams();
  const [showCalendar, setShowCalendar] = useState(false);
  const [timeOptions, setTimeOptions] = useState<string[]>([]);

  const { user, systemSettings, bookingTotalAmount } = useSelector(
    (state: RootState) => ({
      systemSettings: state.auth.systemSettings,
      bookingTotalAmount: state.booking.bookingTotalAmount,
      user: state.auth.user,
    })
  );

  useEffect(() => {
    if (systemSettings.booking_start_time && systemSettings.booking_end_time) {
      const options = generateTimeOptions(
        systemSettings.booking_start_time,
        systemSettings.booking_end_time,
        0
      );
      setTimeOptions(options);
    }
  }, [systemSettings.booking_start_time, systemSettings.booking_end_time]);

  return (
    <>
      <div className="booking-information-card booking-type-card mb-0  d-none d-md-block">
        <div className="booking-info-head">
          <h5>Trip Date & Time</h5>
        </div>

        <div className="booking-info-body">
          <div className="row">
            <div className="col-6">
              <div className="input-block date-widget">
                <label className="form-label">Start Date</label>

                <Calendar
                  className="input-block bg-grey"
                  minDate={new Date()}
                  value={
                    watch('booking_start_date')
                      ? dayjs(watch('booking_start_date'))?.toDate()
                      : null
                  } // Ensure it's a Date object
                  // onChange={(e) => {
                  //     setValue("booking_start_date", e.target.value, { shouldValidate: true })
                  // }}

                  onChange={(e) => {
                    setValue('booking_start_date', e.target.value, {
                      shouldValidate: true,
                    });

                    const date = e.value as Date;
                    const time = watch('booking_start_time'); // Could be "08:00" or "8:00 AM"
                    const duration = parseInt(
                      systemSettings?.booking_min_duration || '0'
                    );

                    if (date && typeof time === 'string' && duration > 0) {
                      // Normalize date string
                      const dateString = `${date.getFullYear()}-${(
                        date.getMonth() + 1
                      )
                        .toString()
                        .padStart(
                          2,
                          '0'
                        )}-${date.getDate().toString().padStart(2, '0')}`;

                      let hours = 0;
                      let minutes = 0;

                      // Match 24-hour format
                      const match24 = time.match(/^(\d{1,2}):(\d{2})$/);
                      // Match 12-hour format with AM/PM
                      const match12 = time.match(
                        /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i
                      );

                      if (match24) {
                        hours = parseInt(match24[1]);
                        minutes = parseInt(match24[2]);
                      } else if (match12) {
                        hours = parseInt(match12[1]);
                        minutes = parseInt(match12[2]);
                        const period = match12[3].toUpperCase();
                        if (period === 'PM' && hours !== 12) hours += 12;
                        if (period === 'AM' && hours === 12) hours = 0;
                      } else {
                        console.warn('Time format not supported:', time);
                        return;
                      }

                      const startDateTime = new Date(dateString);
                      startDateTime.setHours(hours, minutes, 0, 0);

                      if (isNaN(startDateTime.getTime())) {
                        console.error('Invalid startDateTime:', startDateTime);
                        return;
                      }

                      const endDateTime = new Date(startDateTime);
                      endDateTime.setDate(endDateTime.getDate() + duration);

                      setValue(
                        'booking_return_date',
                        moment(endDateTime).format('YYYY-MM-DD'),
                        {
                          shouldValidate: true,
                        }
                      );
                    } else {
                      console.warn(
                        'Date or time invalid — skipping date computation.'
                      );
                    }
                  }}
                  onHide={() => setShowCalendar(false)}
                  visible={showCalendar}
                  readOnlyInput
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-block time-widge">
                <label className="form-label">Start Time </label>

                <select
                  value={watch('booking_start_time')}
                  onChange={(e) => {
                    setValue('booking_start_time', e.target.value, {
                      shouldValidate: true,
                    });

                    setValue('booking_return_time', e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                  className=" form-control form-select px-2"
                >
                  {timeOptions.map((time, index) => (
                    <option key={index} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="input-block date-widget">
                <label className="form-label">Return Date</label>

                <Calendar
                  // className="form-control  "
                  value={
                    watch('booking_return_date')
                      ? dayjs(watch('booking_return_date'))?.toDate()
                      : null
                  } // Ensure it's a Date object
                  onChange={(e) => {
                    setValue('booking_return_date', e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                  onHide={() => setShowCalendar(false)}
                  visible={showCalendar}
                  readOnlyInput
                />
              </div>
            </div>
            <div className="col-6">
              <div className="input-block time-widge">
                <label className="form-label">Return Time</label>

                <select
                  value={watch('booking_return_time')}
                  onChange={(e) => {
                    setValue('booking_return_time', e.target.value, {
                      shouldValidate: true,
                    });
                  }}
                  className="form-control form-select px-2"
                >
                  {timeOptions.map((time, index) => (
                    <option key={index} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="booking-info-btns d-none  d-md-flex  justify-content-end ">
        {user?.id ? (
          bookingTotalAmount?.total && (
            <button
              type="submit"
              onClick={nextStep}
              className="btn btn-primary me-1 mt-1"
            >
              Continue Booking
            </button>
          )
        ) : (
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#login"
            className="btn btn-primary me-1 mt-1"
          >
            Continue Booking
          </button>
        )}

        <Link
          to={`${routes.listingDetails}/${vin}`}
          className="btn btn-secondary mt-1"
        >
          Back to Car Details
        </Link>
      </div>
    </>
  );
};

export default BookingCheckout;
